import { useState } from "react";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import brandLogo from '../assets/brand/logo.png';
import './LoginForm.css';

export default function LoginForm({ onLogin }) {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    // Llamamos al backend via LoginPage
    if (onLogin) {
      onLogin({ phone, password }).catch(err => {
        setError(err.message || "Error en el login");
        toast.error(err.message || "Error en el login");
      });
    }
  };

  return (
    <main className="turnoonline-login login-widget-container">
      <section className="turnoon-login-brand-panel" aria-label="TurnoOnline.com Odontología">
        <img
          src={brandLogo}
          alt="TurnoOnline.com Odontología"
          className="turnoon-login-brand-logo"
        />
        <p>Gestión simple y segura para tu consultorio odontológico.</p>
      </section>

      <form className="turnoon-login-form login-widget-form" onSubmit={handleSubmit}>
        <header className="turnoon-login-form-header">
          <h1>Ingresar</h1>
          <p>Accedé con tus datos para administrar tu consultorio.</p>
        </header>

        <div className="turnoon-login-field">
          <label htmlFor="login-phone">Teléfono WhatsApp</label>
          <input
            id="login-phone"
            type="text"
            name="phone"
            placeholder="Ej. 11 1234 5678"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
            autoComplete="username"
            className="turnoon-login-input"
          />
        </div>

        <div className="turnoon-login-field">
          <label htmlFor="login-password">Contraseña</label>
          <input
            id="login-password"
            type="password"
            name="password"
            placeholder="Ingresá tu contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            className="turnoon-login-input"
          />
        </div>

        {error && <p className="turnoon-login-error" role="alert">{error}</p>}
        <button className="turnoon-login-submit" type="submit">Ingresar</button>
      </form>
      <ToastContainer position="top-center" autoClose={1200} hideProgressBar theme="colored" />
    </main>
  );
}
